module.exports = __webpack_public_path__ + "img/why-ai-agents-break-in-production.a3c00d26.jpg";